export default class Util {
  static showErrorAlert = (error: any) => {
    alert(error?.response?.data?.message ?? error?.message)
  }
}
